import { useFormContext } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    name?: string;
    label?: string;
    tabIndex?: number;
    autoFocus?: boolean;
    disabled?: boolean;
}

const Password: React.FC<Props> = ({ name = "password", tabIndex, autoFocus, label, disabled = false }) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    <ui.FormLabel>{label ?? "Password"}</ui.FormLabel>
                    <ui.FormControl>
                        <ui.Input
                            data-testid="password-input"
                            disabled={disabled}
                            autoFocus={autoFocus}
                            tabIndex={tabIndex}
                            autoComplete="current-password"
                            type="password"
                            placeholder="Enter your password"
                            {...field}
                        />
                    </ui.FormControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Password;
